import React from 'react';
import App from './App';
import theme from 'theme/lightTheme'
import ReactDOM from 'react-dom/client';
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Router>
      <Switch>
        <Route exact path="*" component={App} />
      </Switch>
    </Router>
  </ThemeProvider>
);
